// src/components/LocationSection.js

import React from "react";
import "./styles.css";
const LocationSection = () => {
  // Mã nhúng Google Map của HABAKO M&E (Mã mẫu)
  // Vui lòng thay thế bằng iframe code THỰC TẾ của địa chỉ công ty bạn.
  const mapEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7453.924549012556!2d105.90270159999997!3d20.91383740000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1svi!2s!4v1765553662260!5m2!1svi!2s"; // Thay mã này

  return (
    <section className="location-section">
      <h2 className="location__title">VỊ TRÍ CÔNG TY CHÚNG TÔI</h2>
      <p className="location__description">
        Ghé thăm văn phòng và nhà xưởng của HABAKO M&E để trao đổi về dự án của
        bạn.
      </p>

      <div className="location__map-container">
        <iframe
          src={mapEmbedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Vị trí Văn phòng Công ty Habako M&E"
        ></iframe>
      </div>
    </section>
  );
};

export default LocationSection;
